// Stripe configuration - uses environment-specific keys
const stripeConfig = {
  publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
};

// Validate config on import
if (!stripeConfig.publishableKey) {
  console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY not found in environment');
}

export default stripeConfig;